import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class BatchOpenAmendedService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Accept filterParams and rowData parameters
  batchOpenPshipsInAmended(
    baseUrl: string,
    settings: any,
    data: any[],
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    
    // 🚀 CRITICAL: Use correct URL construction (baseUrl contains /gtw/)
    const url = `${baseUrl}/saveJsonObject?action_code=44jw2d`;

    // Build clob_data and clob_settings exactly as specified
    const clob_data = JSON.stringify(data);
    const clob_settings = JSON.stringify(settings);

    // 🚀 CRITICAL: Build exact parameter structure as specified
    let params: any = {};
    
    // Core parameters from settings
    params.tax_year = settings.tax_year || filterParams.tax_year;
    params.scenario = settings.scenario || filterParams.scenario;
    params.jcd_key = settings.jcd_key || globalService?.jcd_key;
    params.sso_id = settings.sso_id;
    
    // Required fields
    params.process_name = "Partnership Batch-Open in Amended";
    params.issue_id = globalService?.issue_id || filterParams.issue_id || '';
    params.issue_short_desc = globalService?.issue_short_desc || filterParams.issue_short_desc || '';
    
    // Build checkLockedbj with scenario_key only
    const checkLockedbj = [{
      "scenario_key": parseInt(settings.scenario || filterParams.scenario || '81')
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    
    // Additional required fields - make dynamic like other components
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    
    // Add clob_data and clob_settings
    params.clob_data = clob_data;
    params.clob_settings = clob_settings;

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // 🚀 CRITICAL: Fetch max count entities for allocation limit
  fetchMaxCountEntities(
    baseUrl: string,
    screenKey: string,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    
    const url = `${baseUrl}/loadJsonObject`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({
      action_code: 'mysfkb',
      screen_key: screenKey
    }, params);

    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // Additional utility methods for partnership batch operations
  validatePartnershipSelection(
    partnerships: any[],
    allocationLimit: number
  ): { isValid: boolean; message: string } {
    if (!partnerships || partnerships.length === 0) {
      return {
        isValid: false,
        message: 'No partnerships selected for processing.'
      };
    }

    if (partnerships.length > allocationLimit) {
      return {
        isValid: false,
        message: `Can't select more than ${allocationLimit} partnerships.`
      };
    }

    return {
      isValid: true,
      message: 'Selection is valid.'
    };
  }

  // Process grid data to extract partnership information
  processPartnershipGridData(gridData: any): any[] {
    const processedData: any[] = [];
    
    if (gridData && typeof gridData === 'object') {
      for (let key in gridData) {
        if (gridData[key] && gridData[key].data) {
          const gridObj: any = {};
          gridObj["ho_le_key"] = gridData[key].data.HO_LE_KEY;
          
          // Add additional partnership data if available
          if (gridData[key].data.LEID) {
            gridObj["leid"] = gridData[key].data.LEID;
          }
          if (gridData[key].data.PARTNERSHIP_NAME) {
            gridObj["partnership_name"] = gridData[key].data.PARTNERSHIP_NAME;
          }
          if (gridData[key].data.TAX_YEAR) {
            gridObj["tax_year"] = gridData[key].data.TAX_YEAR;
          }
          
          processedData.push(gridObj);
        }
      }
    }
    
    return processedData;
  }

  // Build comprehensive settings object for batch operations
  buildBatchSettings(
    filterParams: any,
    globalService: any,
    userSettings: any
  ): any {
    return {
      tax_year: filterParams.tax_year || '',
      scenario: filterParams.scenario || '',
      jcd_key: globalService?.jcd_key || '',
      sso_id: userSettings?.user?.sso_id || '',
      process_timestamp: new Date().toISOString(),
      batch_type: 'PARTNERSHIP_BATCH_OPEN_AMENDED'
    };
  }
}
